import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
interface CTAButtonProps {
  onClick?: () => void;
  className?: string;
  text?: string;
}
export function CTAButton({
  onClick,
  className = '',
  text = 'Ordenar Ahora – Pago Contra Entrega'
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://glowliftessencemx.com/products/rodillera-de-calor-usb', '_blank');
    }
  };
  return <button onClick={handleClick} className={`w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg transform transition-all hover:scale-105 flex items-center justify-center gap-3 text-lg md:text-xl animate-pulse ${className}`} data-id="element-228">
      <ShoppingCartIcon className="w-6 h-6" data-id="element-229" />
      <span data-id="element-230">{text}</span>
    </button>;
}